import React from 'react';
import { Bot, CheckCircle2, Filter, ShieldAlert, Waypoints } from 'lucide-react';

const scoreRows = (review) => [
  ['content-filter', 'Provider safety', review.component_scores?.content_filter || 0, Filter],
  ['safety-flags', 'Safety markers', review.component_scores?.safety_flags || 0, ShieldAlert],
  ['continuity-quality', 'Continuity & quality', review.component_scores?.continuity_quality || 0, Waypoints],
  ['jev', 'Jev ambiguity rank', review.ai_score ?? null, Bot],
];

export const HybridScoreCard = ({ review }) => (
  <section className="border border-border bg-panel-header/15 p-4" data-testid="hybrid-score-card">
    <div className="flex items-start justify-between gap-4">
      <div>
        <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Hybrid priority</div>
        <div className="mt-1 flex items-baseline gap-2">
          <span className="font-mono-stat text-3xl font-bold tabular-nums" data-testid="hybrid-score-value">{review.hybrid_score}</span>
          <span className="text-xs font-semibold uppercase text-muted-foreground">/ 100 · {review.risk_level}</span>
        </div>
      </div>
      <div className="text-right">
        <div className="text-[10px] uppercase tracking-wider text-muted-foreground">AI state</div>
        <div className="mt-1 inline-flex items-center gap-1 border border-border bg-card px-2 py-1 text-[10px] font-semibold" data-testid="review-ai-status">
          {review.ai_status === 'complete' ? <CheckCircle2 className="h-3 w-3 text-emerald-600" /> : <Bot className="h-3 w-3" />}
          {review.ai_status?.replaceAll('_', ' ')}
        </div>
      </div>
    </div>
    <div className="mt-4 grid gap-2 sm:grid-cols-2">
      {scoreRows(review).map(([key, label, value, Icon]) => (
        <div key={key} className="border border-border bg-card px-3 py-2" data-testid={`score-component-${key}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="inline-flex items-center gap-1.5 text-[10.5px] text-muted-foreground"><Icon className="h-3.5 w-3.5" /> {label}</span>
            <span className="font-mono-stat text-xs font-semibold tabular-nums">{value === null ? '—' : Math.round(value)}</span>
          </div>
          <div className="mt-2 h-1.5 overflow-hidden bg-secondary">
            <div className="h-full bg-primary transition-[width] duration-500" style={{ width: `${Math.max(0, Math.min(100, value || 0))}%` }} />
          </div>
        </div>
      ))}
    </div>
    {review.ai_focus && (
      <p className="mt-3 text-[10.5px] text-muted-foreground" data-testid="review-ai-focus">
        AI focus: <b className="text-foreground">{review.ai_focus}</b> · human-review probability {Math.round((review.needs_human_probability || 0) * 100)}%
      </p>
    )}
  </section>
);